import { Component } from "@angular/core";
import { LoaderService } from "./_shared/services/loader.service";
import { CommonHttpService } from "./components/commonHttp.service";
import { environment } from "../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "app";
  baseUrl: any = environment.apiUrl;
  showLoader: boolean = true;
  pageDown: boolean = true;
  utm_source;
  oneSignalInit: any
  constructor(
    private loaderService: LoaderService,
    private service: CommonHttpService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams
      .filter((params) => params.utm_source)
      .subscribe((params) => {

        this.utm_source = params.utm_source;
        console.log(this.utm_source); // popular
        if (this.utm_source == "phonepe") {
          localStorage.setItem("utm_sources", JSON.stringify(this.utm_source));
          //   console.log(JSON.parse(localStorage.getItem("utm_sources")));

          window.scrollTo(0, 0);
        }
      });
  }
  addScript(fileSrc, callback) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.onload = callback;
    script.src = fileSrc;
    head.appendChild(script);
  }
  ngOnInit() {

    this.addScript('https://cdn.onesignal.com/sdks/OneSignalSDK.js', (callback) => {
      console.log('OneSignal Script Loaded');
      this.initOneSignal();
    })


    this.service.get(this.baseUrl + "ErrorStatusAPI/GetAllStatus/").subscribe(
      (data) => {
        console.log(data);
        var statusForPageDown = data;
        console.log(statusForPageDown.length);
        for (let i = 0; i < statusForPageDown.length; i++) {
          if (statusForPageDown[i].id == 2) {
            this.pageDown = statusForPageDown[i].status;
          }
        }
      },
      (error) => { }
    );

    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }
  initOneSignal() {
    var OneSignal = window['OneSignal'] || [];
    console.log("Init OneSignal");
    OneSignal.push(["init", {
      appId: "88725aca-563a-4cd0-b594-73be7ef996f0",
      safari_web_id: "web.onesignal.auto.34975c41-96f8-43c9-89c6-048b8e5234aa",
      autoRegister: true,
      allowLocalhostAsSecureOrigin: true,
      notifyButton: {
        enable: true
      }
    }]);

    console.log('OneSignal Initialized');
    OneSignal.push(function () {
      console.log('Register For Push');
      OneSignal.push(["registerForPushNotifications"])
    });
    OneSignal.push(function () {
      // Occurs when the user's subscription changes to a new value.
      OneSignal.on('subscriptionChange', function (isSubscribed) {
        console.log("The user's subscription state is now:", isSubscribed);
        OneSignal.getUserId().then(function (userId) {
          console.log("User ID is", userId);
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/app.component.ts